import { render, staticRenderFns } from "./UiBuy.vue?vue&type=template&id=3bb87530&scoped=true&"
import script from "./UiBuy.vue?vue&type=script&lang=js&"
export * from "./UiBuy.vue?vue&type=script&lang=js&"
import style0 from "./UiBuy.vue?vue&type=style&index=0&id=3bb87530&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb87530",
  null
  
)

export default component.exports